
namespace RioERP.Users {
    export class BrandAmbassadorColumns {
        static columnsKey = 'Users.BrandAmbassador';
    }
}